import React, { useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { getLetterTemplates, createLetterTemplate } from "../../../services/letterTemplates";
import SelectField from "../SelectField";

const TelecareEditor = ({ initialValue = "initial content" }) => {
  const editorRef = useRef(null);

  const [tplName, setTplName] = useState("");
  // existing templates options
  const [extTplsOpts, setExtTplsOpts] = useState([]);
  const [savedTpls, setSavedTpls] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    // get letter templates
    async function getTemplates() {
      const tpls = await getLetterTemplates();
      setSavedTpls(tpls);
      setExtTplsOpts(tpls.map((tpl) => ({ label: tpl.name, value: tpl.name })));
    }
    getTemplates();
  }, []);

  const save = async () => {
    if (editorRef.current) {
      const content = editorRef.current.getContent();
      editorRef.current.setDirty(false);
      setIsSaving(true);
      await createLetterTemplate({ name: tplName, content });
      setIsSaving(false);
    }
  };

  const handleEditorChange = (e) => {
    console.log("Content was updated:", e.target.getContent());
  };

  const handleExtTplsOptsChange = (e) => {
    const tpl = savedTpls.find((tpl) => tpl.name === e.target.value);
    editorRef.current.setContent(tpl.content);
  };

  return (
    <>
      <div className="columns">
        <div className="column is-3">
          <SelectField label="Existing Templates" options={extTplsOpts} onChange={handleExtTplsOptsChange} />
        </div>
      </div>

      <Editor
        apiKey="038hwxmf8dp9x2qsjdd9q21atbe8rixdestbccjt4ifmkkkb"
        initialValue={initialValue}
        onInit={(evt, editor) => (editorRef.current = editor)}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            "advlist autolink lists link image",
            "charmap print preview anchor help",
            "searchreplace visualblocks code",
            "insertdatetime media table paste wordcount",
          ],
          toolbar:
            "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | image preview | help",
          file_picker_types: "image",
          file_picker_callback: function (cb, value, meta) {
            var input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");

            /*
      Note: In modern browsers input[type="file"] is functional without
      even adding it to the DOM, but that might not be the case in some older
      or quirky browsers like IE, so you might want to add it to the DOM
      just in case, and visually hide it. And do not forget do remove it
      once you do not need it anymore.
    */

            input.onchange = function () {
              var file = this.files[0];

              var reader = new FileReader();
              reader.onload = function () {
                /*
          Note: Now we need to register the blob in TinyMCEs image blob
          registry. In the next release this part hopefully won't be
          necessary, as we are looking to handle it internally.
        */
                var id = "blobid" + new Date().getTime();
                var blobCache = editorRef.current.editorUpload.blobCache;
                var base64 = reader.result.split(",")[1];
                var blobInfo = blobCache.create(id, file, base64);
                blobCache.add(blobInfo);

                /* call the callback and populate the Title field with the file name */
                cb(blobInfo.blobUri(), { title: file.name });
              };
              reader.readAsDataURL(file);
            };

            input.click();
          },
        }}
        onChange={handleEditorChange}
      />
      <hr />
      <div className="field has-addons">
        <div className="control">
          <input
            className="input is-small"
            type="text"
            placeholder="Name of template"
            value={tplName}
            onChange={(e) => setTplName(e.target.value)}
          />
        </div>
        <div className="control">
          <span className={`${isSaving ? "is-loading " : ""}button is-info is-size-7`} onClick={save}>
            Save as template
          </span>
        </div>
      </div>
    </>
  );
};

export default TelecareEditor;
